import React, { useState } from "react";
import * as Yup from "yup";
import { Formik, Field } from "formik";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import "../../Style/CreateTask.css";
import "../../Style/NewCustomer.css";
import MainSidebar from "../Mainsidebar";
import UserNavbar from "../UserNavbar";
import UserFooter from "../UserFooter";
import { path_url } from "../../Config/config";
import { useNavigate } from "react-router-dom";
import { getAuthHeader } from "../../Utils/auth";

// Field names below match the backend Expense schema exactly
// (billnumber, subject, expensedate, category, expenseamount,
// status, notes, reportto, approvalstatus, address fields) —
// confirmed via Swagger /v3/api-docs.
const expenseSchema = Yup.object().shape({
  billnumber: Yup.string().required("Required"),
  subject: Yup.string().required("Required"),
  category: Yup.string().required("Required"),
  expensedate: Yup.string().required("Required"),
  expenseamount: Yup.number()
    .typeError("Must be a number")
    .positive("Must be positive")
    .required("Required"),
});

export default function NewExpense() {
  const navigate = useNavigate();
  const [hamburger, sethamburger] = useState(true);
  const [isRightMenu, setisRightMenu] = useState(false);
  const [isSearchShow, setIsSearchShow] = useState(false);
  const [fullScreen, setFullScreen] = useState(true);

  const handleScreenEnter = () => {
    setFullScreen(false);
    document.body.requestFullscreen();
  };
  const handleScreenExit = () => {
    setFullScreen(true);
    document.exitFullscreen();
  };
  const handelShow = () => setIsSearchShow(!isSearchShow);
  const handelRightMenuShow = () => setisRightMenu(!isRightMenu);
  const handleclickonbutton = (hamburger) => {
    if (document.documentElement.clientWidth <= 800)
      return { width: "100%", left: "0rem" };
    else
      return {
        width: !hamburger && "-webkit-fill-available",
        left: !hamburger && "3.7rem",
      };
  };
  const handleclickonbutton1 = (hamburger) => {
    if (document.documentElement.clientWidth <= 800) {
      return { display: hamburger && "none" };
    }
  };

  const Status = [
    { value: "Pending" },
    { value: "Approved" },
    { value: "Rejected" },
    { value: "Paid" },
  ];

  const ApprovalStatus = [
    { value: "Pending" },
    { value: "Approved" },
    { value: "Rejected" },
  ];

  return (
    <div className="con1 d-flex">
      <div className="subcon1" style={handleclickonbutton1(hamburger)}>
        <MainSidebar hamburger={hamburger} sethamburger={sethamburger} />
      </div>
      <div className="subcon2" style={handleclickonbutton(hamburger)}>
        <UserNavbar
          hamburger={hamburger}
          sethamburger={sethamburger}
          handelRightMenuShow={handelRightMenuShow}
          handelShow={handelShow}
          isSearchShow={isSearchShow}
          handleScreenEnter={handleScreenEnter}
          handleScreenExit={handleScreenExit}
          fullScreen={fullScreen}
        />
        <div className="mt-2">
          <Formik
            initialValues={{
              billnumber: "",
              subject: "",
              category: "",
              expensedate: "",
              expenseamount: "",
              status: "Pending",
              approvalstatus: "Pending",
              notes: "",
              reportto: "",
              add1: "",
              city: "",
              pincode: "",
              state: "",
              country: "",
            }}
            validationSchema={expenseSchema}
            onSubmit={async (values, { resetForm }) => {
              try {
                const adminId = localStorage.getItem("adminId");

                const url = `${path_url}/expense`;
                const payload = {
                  ...values,
                  // Backend schema: expenseamount is "string"
                  expenseamount: String(values.expenseamount),
                  useradminid: adminId,
                };

                const response = await axios.post(url, payload, {
                  headers: {
                    "Content-Type": "application/json",
                    ...getAuthHeader(),
                  },
                });

                // Backend POST /expense returns HTTP 201 Created.
                // Treat both 200 and 201 as success.
                const httpStatus = response.status;
                const isSuccess = httpStatus === 201 || httpStatus === 200;

                if (isSuccess) {
                  toast.success("Expense created successfully");
                  resetForm();
                  setTimeout(() => {
                    navigate("/expense-dashboard");
                  }, 1000);
                } else {
                  toast.error(
                    response.data?.body || "Failed to create expense"
                  );
                }
              } catch (error) {
                console.error(error);
                if (error.response && error.response.status === 401) {
                  localStorage.removeItem("accessToken");
                  navigate("/login");
                  return;
                }
                toast.error("Something went wrong while creating the expense");
              }
            }}
          >
            {(formik) => (
              <form onSubmit={formik.handleSubmit}>
                <fieldset>
                  <div className="col-12 d-flex justify-content-center">
                    <div className="bg-white col-11 cont">
                      <div
                        style={{ boxShadow: "0 1px 1px lightgray" }}
                        className="d-flex flexDir-column mt-2 col-12 elevation-2 mb-2 justify-content-between"
                      >
                        <p style={{ color: "gray" }} className="p-1 m-0 custom-font-size">
                          <strong>New Expense</strong>
                        </p>
                      </div>

                      <div className="d-flex flex-wrap">
                        <div className="col-12 col-md-6 pl-0 pr-0">
                          <div className="col-12 col-sm-12 d-flex mb-2">
                            <div className="col-12 col-sm-4 text-right-lg">
                              <label style={{ fontSize: 15 }}>
                                <strong>Bill Number</strong>
                                <sup style={{ color: "red" }}>*</sup>
                              </label>
                            </div>
                            <div className="col-12 col-sm-8 forms">
                              <input
                                type="text"
                                placeholder="Bill number"
                                name="billnumber"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.billnumber}
                              />
                              {formik.touched.billnumber && formik.errors.billnumber && (
                                <span style={{ color: "red" }}>{formik.errors.billnumber}</span>
                              )}
                            </div>
                          </div>

                          <div className="col-12 col-sm-12 d-flex mb-2">
                            <div className="col-12 col-sm-4 text-right-lg">
                              <label style={{ fontSize: 15 }}>
                                <strong>Subject</strong>
                                <sup style={{ color: "red" }}>*</sup>
                              </label>
                            </div>
                            <div className="col-12 col-sm-8 forms">
                              <input
                                type="text"
                                placeholder="e.g. Client visit travel"
                                name="subject"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.subject}
                              />
                              {formik.touched.subject && formik.errors.subject && (
                                <span style={{ color: "red" }}>{formik.errors.subject}</span>
                              )}
                            </div>
                          </div>

                          <div className="col-12 col-sm-12 d-flex mb-2">
                            <div className="col-12 col-sm-4 text-right-lg">
                              <label style={{ fontSize: 15 }}>
                                <strong>Category</strong>
                                <sup style={{ color: "red" }}>*</sup>
                              </label>
                            </div>
                            <div className="col-12 col-sm-8 forms">
                              <input
                                type="text"
                                placeholder="e.g. Travel, Office Supplies"
                                name="category"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.category}
                              />
                              {formik.touched.category && formik.errors.category && (
                                <span style={{ color: "red" }}>{formik.errors.category}</span>
                              )}
                            </div>
                          </div>

                          <div className="col-12 col-sm-12 d-flex mb-2">
                            <div className="col-12 col-sm-4 text-right-lg">
                              <label style={{ fontSize: 15 }}>
                                <strong>Date</strong>
                                <sup style={{ color: "red" }}>*</sup>
                              </label>
                            </div>
                            <div className="col-12 col-sm-8 forms">
                              <input
                                className="input-field date"
                                type="date"
                                name="expensedate"
                                value={formik.values.expensedate}
                                onChange={formik.handleChange}
                              />
                              {formik.touched.expensedate && formik.errors.expensedate && (
                                <span style={{ color: "red" }}>{formik.errors.expensedate}</span>
                              )}
                            </div>
                          </div>

                          <div className="col-12 col-sm-12 d-flex mb-2">
                            <div className="col-12 col-sm-4 text-right-lg">
                              <label style={{ fontSize: 15 }}>
                                <strong>Report To</strong>
                              </label>
                            </div>
                            <div className="col-12 col-sm-8 forms">
                              <input
                                type="text"
                                placeholder="Report to"
                                name="reportto"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.reportto}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-6 pl-0 pr-0">
                          <div className="col-12 col-sm-12 d-flex mb-2">
                            <div className="col-12 col-sm-4 text-right-lg">
                              <label style={{ fontSize: 15 }}>
                                <strong>Amount</strong>
                                <sup style={{ color: "red" }}>*</sup>
                              </label>
                            </div>
                            <div className="col-12 col-sm-8 forms">
                              <input
                                type="number"
                                step="0.01"
                                placeholder="0.00"
                                name="expenseamount"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.expenseamount}
                              />
                              {formik.touched.expenseamount && formik.errors.expenseamount && (
                                <span style={{ color: "red" }}>{formik.errors.expenseamount}</span>
                              )}
                            </div>
                          </div>

                          <div className="col-12 col-sm-12 d-flex mb-2">
                            <div className="col-12 col-sm-4 text-right-lg">
                              <label style={{ fontSize: 15 }}>
                                <strong>Status</strong>
                              </label>
                            </div>
                            <div className="col-12 col-sm-8">
                              <Field as="select" name="status" className="selectBox custom-select">
                                {Status.map((s) => (
                                  <option key={s.value} value={s.value}>
                                    {s.value}
                                  </option>
                                ))}
                              </Field>
                            </div>
                          </div>

                          <div className="col-12 col-sm-12 d-flex mb-2">
                            <div className="col-12 col-sm-4 text-right-lg">
                              <label style={{ fontSize: 15 }}>
                                <strong>Approval Status</strong>
                              </label>
                            </div>
                            <div className="col-12 col-sm-8">
                              <Field as="select" name="approvalstatus" className="selectBox custom-select">
                                {ApprovalStatus.map((s) => (
                                  <option key={s.value} value={s.value}>
                                    {s.value}
                                  </option>
                                ))}
                              </Field>
                            </div>
                          </div>

                          <div className="col-12 col-sm-12 d-flex mb-2">
                            <div className="col-12 col-sm-4 text-right-lg">
                              <label style={{ fontSize: 15 }}>
                                <strong>Notes</strong>
                              </label>
                            </div>
                            <div className="col-12 col-sm-8 forms">
                              <textarea
                                name="notes"
                                rows={4}
                                placeholder="Notes"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.notes}
                              />
                            </div>
                          </div>

                          <div className="col-12 col-sm-12 d-flex mb-2">
                            <div className="col-12 col-sm-6 d-flex justify-content-center p-2">
                              <button
                                type="button"
                                className="btn btn-sm btn-light border rounded border-gray"
                                onClick={() => {
                                  formik.resetForm();
                                  navigate(-1);
                                }}
                              >
                                Cancel
                              </button>
                            </div>
                            <div className="col-12 col-sm-6 d-flex justify-content-center p-2">
                              <button
                                type="submit"
                                className="btn btn-sm border rounded border-gray btn-info"
                                style={{ backgroundColor: "rgba(52, 58, 64, 255)" }}
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </form>
            )}
          </Formik>
        </div>
        <UserFooter />
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </div>
    </div>
  );
}